import React from "react";
import "./FooterPanel.css";

/**
 * FooterPanel component to display the footer section of the panel layout.
 *
 * How it works:
 * - Renders a footer element with a copyright notice.
 * - Uses unique class names to ensure styles are scoped to this component.
 *
 * Parameters: None.
 * Return type: JSX.Element (the footer section for the panel).
 * Usage: Place <FooterPanel /> at the bottom of your panel layout to show the footer.
 */
const FooterPanel = () => {
  return (
    <footer className="my-footer footer-panel">
      <div className="footer-text">
        © 2025 Vision Security — All rights reserved.
      </div>
    </footer>
  );
};

export default FooterPanel;
